export type RingEntry = { seq: number; samples: Int16Array };

/**
 * Pre-Roll-Ring: hängt `entry` hinten an und trimmt vorne, bis `ring.length <= max`.
 * Mutiert `ring` in place (ein per-Paket aufgerufener Hot-Path → keine Neu-Allokation)
 * und gibt dieselbe Referenz zurück. `max <= 0` leert den Ring.
 */
export function pushRing(ring: RingEntry[], entry: RingEntry, max: number): RingEntry[] {
  ring.push(entry);
  while (ring.length > max) ring.shift();
  return ring;
}
